import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from '../jobs/jobs-table.jsx';
import DriversTable from '../drivers/drivers-table.jsx';
import PortalAccountsTable from '../portal-admin/portal-accounts-table.jsx';
import CustomersTable from '../customers/customers-table.jsx';

export default class PortalSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      searchResults: props.searchResults || {
        jobs: [],
        users: [],
        drivers: [],
        vehicles: [],
        customers: [],
        pickup_addresses: [],
        dropoff_addresses: [],
        customerAllJobsPage: false
      },
      numberOfSearchResults: '0',
      searchFor: '',
      searchForLabel: '',
      pluralResults: 's',
      isFetching: false,
      activeTab: 'jobs',
      loadedTabs: {},
      searchResultsJobs: [],
      searchResultsUsers: [],
      searchResultsDrivers: [],
      searchResultsCustomers: [],
      searchActivity: 1,
      errorMessage: '',
    };
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    let isCustomerLogin = $('#data-compnay-id').attr('data-is-customer-login');
    isCustomerLogin = ((isCustomerLogin == 1) ? true : false);
    this.setState({customerAllJobsPage: isCustomerLogin});
    if (isCustomerLogin) {
      $('#react-component-g4-logistics-portal-search').find('.search-results').attr('id', 'react-component-g4-logistics-portal-view-customer-with-all-jobs');  
    }
  }

  handleSearchInput = (event) => {
    if (event.key === 'Enter') {
      this.searchData(this.state.activeTab, true);
    }
  };

  handleTabChange(tab) {
    this.setState({ activeTab: tab }, () => {
      const searchInput = document.getElementById('modal-search-input-box');
      const searchFor = searchInput ? searchInput.value.trim() : this.state.searchFor;
      
      if (searchFor.length > 0 && !this.state.loadedTabs[tab]) {
        this.searchData(tab, false);
      }
    });
  }

  searchData(targetTab = null, isNewSearch = true) {
    const tabToSearch = targetTab || this.state.activeTab || 'jobs';
    const searchInput = document.getElementById('modal-search-input-box');
    const searchFor = searchInput ? searchInput.value.trim() : this.state.searchFor;

    if (searchFor.length < 1) {
      return;
    }

    const currentSearchFor = this.state.searchFor;
    const isDifferentQuery = isNewSearch || (searchFor !== currentSearchFor);

    let nextLoadedTabs = isDifferentQuery ? {} : { ...this.state.loadedTabs };
    let jobs = isDifferentQuery ? [] : [...this.state.searchResultsJobs];
    let users = isDifferentQuery ? [] : [...this.state.searchResultsUsers];
    let drivers = isDifferentQuery ? [] : [...this.state.searchResultsDrivers];
    let customers = isDifferentQuery ? [] : [...this.state.searchResultsCustomers];

    this.setState({
      isFetching: true,
      searchFor: searchFor,
      loadedTabs: nextLoadedTabs,
      searchResultsJobs: jobs,
      searchResultsUsers: users,
      searchResultsDrivers: drivers,
      searchResultsCustomers: customers,
      errorMessage: ''
    });

    let formData = new FormData();
    formData.append('search_for', searchFor);
    formData.append('is_customer_login', this.state.customerAllJobsPage);
    formData.append('tab', tabToSearch);

    fetch("/api/v1/portal/search", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token,
        "Accept": 'application/json'
      },
      body: formData,
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      return response.json();
    })
    .then((searchResults) => {
      let nextJobs = isDifferentQuery ? [] : [...this.state.searchResultsJobs];
      let nextUsers = isDifferentQuery ? [] : [...this.state.searchResultsUsers];
      let nextDrivers = isDifferentQuery ? [] : [...this.state.searchResultsDrivers];
      let nextCustomers = isDifferentQuery ? [] : [...this.state.searchResultsCustomers];

      if (tabToSearch === 'jobs' && Array.isArray(searchResults.jobs)) {
        nextJobs = searchResults.jobs;
      }
      if (tabToSearch === 'users' && Array.isArray(searchResults.users)) {
        nextUsers = searchResults.users;
      }
      if (tabToSearch === 'drivers' && Array.isArray(searchResults.drivers)) {
        nextDrivers = searchResults.drivers;
      }
      if (tabToSearch === 'customers' && Array.isArray(searchResults.customers)) {
        nextCustomers = searchResults.customers;
      }

      const loadedTabs = { ...this.state.loadedTabs, [tabToSearch]: true };
      const totalCount = this.state.customerAllJobsPage
        ? nextJobs.length
        : (nextJobs.length + nextUsers.length + nextDrivers.length + nextCustomers.length);

      const searchForLabel = ` for <em>${searchFor}</em>`;
      let errorMessage = '';
      if (
        (tabToSearch === 'jobs' && nextJobs.length === 0) ||
        (tabToSearch === 'users' && nextUsers.length === 0) ||
        (tabToSearch === 'drivers' && nextDrivers.length === 0) ||
        (tabToSearch === 'customers' && nextCustomers.length === 0)
      ) {
        if (totalCount === 0) {
          errorMessage = "No data found.";
        }
      }

      this.setState({
        searchResultsJobs: nextJobs,
        searchResultsUsers: nextUsers,
        searchResultsDrivers: nextDrivers,
        searchResultsCustomers: nextCustomers,
        loadedTabs: loadedTabs,
        numberOfSearchResults: totalCount,
        pluralResults: totalCount === 1 ? '' : 's',
        searchFor: searchFor,
        searchForLabel: searchForLabel,
        isFetching: false,
        searchActivity: totalCount > 0,
        errorMessage: errorMessage
      });
    })
    .catch((error) => {
      this.setState({
        isFetching: false,
        searchActivity: false,
        errorMessage: 'Something went wrong. Please try again later.'
      });
    });
  }

  render() {
    return (
      <div>
        <div id="search-modal-search-form">
          <div id="search-main-controls-container">
            <input
              type="text"
              id="modal-search-input-box"
              placeholder="type to search..."
              autoComplete="off"
              className="form-control form-control-lg"
              onKeyDown={this.handleSearchInput}
              style={{"width":"90%", "display":"inline"}}/>
            <button
              id="modal-search-button"
              className="btn btn-lg btn-dark"
              style={{"width":"50px"}}
              onClick={() => this.searchData(this.state.activeTab, true)}
              >
              <i className="fa fa-search" alt="[Search]"></i>
            </button>
          </div>
        </div>

        <div id="search-results" className="panel">
          <h2 id="search-results-number-of-search-results">
            {this.state.numberOfSearchResults} search result{this.state.pluralResults}
            <span dangerouslySetInnerHTML={{__html:this.state.searchForLabel}}>
            </span>
          </h2>
          <div className="search-results">
            <div>
              <ul className="nav nav-tabs">
                <li>
                  <a data-toggle="tab" href="#search-results-tabs-jobs-tab"
                     className={this.state.activeTab === 'jobs' ? "active show" : ""}
                     onClick={() => this.handleTabChange('jobs')}>
                    Jobs ({this.state.loadedTabs.jobs ? this.state.searchResultsJobs.length : (this.state.activeTab === 'jobs' ? this.state.searchResultsJobs.length : '0')})
                  </a>
                </li>
                {(!this.state.customerAllJobsPage) ? 
                <li>
                  <a data-toggle="tab" href="#search-results-tabs-users-tab"
                     className={this.state.activeTab === 'users' ? "active show" : ""}
                     onClick={() => this.handleTabChange('users')}>
                    Users ({this.state.loadedTabs.users ? this.state.searchResultsUsers.length : (this.state.activeTab === 'users' ? this.state.searchResultsUsers.length : '0')})
                  </a>
                </li>
                : null}
                {(!this.state.customerAllJobsPage) ? 
                <li>
                  <a data-toggle="tab" href="#search-results-tabs-drivers-tab"
                     className={this.state.activeTab === 'drivers' ? "active show" : ""}
                     onClick={() => this.handleTabChange('drivers')}>
                    Drivers ({this.state.loadedTabs.drivers ? this.state.searchResultsDrivers.length : (this.state.activeTab === 'drivers' ? this.state.searchResultsDrivers.length : '0')})
                  </a>
                </li> 
                : null}
                {(!this.state.customerAllJobsPage) ? 
                <li>
                  <a data-toggle="tab" href="#search-results-tabs-customers-tab"
                     className={this.state.activeTab === 'customers' ? "active show" : ""}
                     onClick={() => this.handleTabChange('customers')}>
                    Customers ({this.state.loadedTabs.customers ? this.state.searchResultsCustomers.length : (this.state.activeTab === 'customers' ? this.state.searchResultsCustomers.length : '0')})
                  </a>
                </li>
                 : null}
              </ul>
              <div className="tab-content-container">
                {this.state.isFetching && (
                  <div className="p-3 text-muted">
                    <i className="fa fa-spinner fa-spin mr-2"></i> Getting Search Results...
                  </div>
                )}
                <div className="tab-content" style={{ display: this.state.isFetching ? 'none' : 'block' }}>
                    <div id="search-results-tabs-jobs-tab"
                      className="tab-pane fade in active show">
                      <JobsTable
                        jobs={this.state.searchResultsJobs}
                        message_if_none='Job not found or available for viewing.'
                        key={"portal-search-result-jobs-table"}
                        customerAllJobsPage={this.state.customerAllJobsPage}
                      />
                    </div>
                    <div id="search-results-tabs-users-tab"
                      className="tab-pane fade">
                      <PortalAccountsTable
                        portal_accounts={this.state.searchResultsUsers}
                        message_if_none='User not found or available for viewing.'
                        key={"portal-search-result-portal-accounts-table"}
                      />
                    </div>
                    <div id="search-results-tabs-drivers-tab"
                      className="tab-pane fade">
                      <DriversTable
                        drivers={this.state.searchResultsDrivers}
                        message_if_none='Driver not found or available for viewing.'
                        key={"portal-search-result-drivers-table"}
                      />
                    </div>
                    <div id="search-results-tabs-customers-tab"
                      className="tab-pane fade">
                      <CustomersTable
                        customers={this.state.searchResultsCustomers}
                        key={"portal-search-result-customers-table"}
                      />
                    </div>
                  {
                    (this.state.searchActivity===false?<h1 className='pt-5'>{this.state.errorMessage}</h1>:null)
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-search'
)) {
  ReactDOM.render(
    <PortalSearch />,
      document.getElementById(
        'react-component-g4-logistics-portal-search'
      )
  );
}
